import React from "react";
import Footer from "../Components/Footer";
import Header from "../Components/Header";


function Contact () {

    return(

        <>

        <Header/>
        <main>
            
  {/*===== HERO AREA START =====*/}
  <div
    className="inner-hero"
    style={{ backgroundImage: "url(assets/img/bg/Ashok.jpg)" }}
  >
    <div className="container">
      <div className="row">
        <div className="col-lg-8 m-auto text-center">
          <div className="inner-main-heading">
            <h1>Contact Us</h1>
            <div className="breadcrumbs-pages">
              {/* <ul>
                <li>
                  <a href="index.html">Home</a>
                </li>
                <li className="angle">
                  <i className="fa-solid fa-angle-right" />
                </li>
                <li>Contact Us</li>
              </ul> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/*===== HERO AREA START =====*/}
  {/*===== CONTACT AREA START =====*/}
  <div className="contact2 sp">
    <div className="container">
      <div className="row">
        <div className="col-lg-4 col-md-6">
          <div className="contact-page-box">
            <div className="icon">
              <img src="assets/img/icons/contact-page-icon1.svg" alt="" />
            </div>
            <div className="content">
              <h3>Email Address</h3>
              <a href="mailto:support@seox.com">support@seox.com</a>
              <a href="mailto:sales@seox.com">sales@seox.com</a>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="contact-page-box">
            <div className="icon">
              <img src="assets/img/icons/contact-page-icon2.svg" alt="" />
            </div>
            <div className="content">
              <h3>Phone Number</h3>
              <a href="tel:+123456-7890">+1 (123) 456-7890</a>
              <a href="tel:+123456-7890">+1 (123) 456-7890</a>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="contact-page-box">
            <div className="icon">
              <img src="assets/img/icons/contact-page-icon3.svg" alt="" />
            </div>
            <div className="content">
              <h3>Office Address</h3>
              <a href="#">123 Innovation Lane,</a>
              <a href="#">Digital City, DX 98765</a>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 mt-60">
          <div className="heading2">
            <div className="contact2-form">
              <span
                className="sub-title"
                data-aos="zoom-in-left"
                data-aos-duration={900}
              >
                <img src="assets/img/icons/span3.svg" alt="" />
                CONTACT US{" "}
              </span>
              <h2 className="text-anime-style-3">Lets Work Together</h2>
              <p
                className="mt-16"
                data-aos="fade-right"
                data-aos-duration={900}
              >
                eady to take your social media presence to the next level? Let’s
                work together to create impactful strategies drive engagement,
                growth, and success for your brand.
              </p>
              <form action="#" data-aos="fade-right" data-aos-duration={1000}>
                <div className="row mt-16">
                  <div className="col-md-6">
                    <div className="single-input">
                      <input type="text" placeholder="First Name" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="single-input">
                      <input type="text" placeholder="Last Name" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="single-input">
                      <input type="email" placeholder="Email Address" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="single-input">
                      <input type="number" placeholder="Phone Number" />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="single-input">
                      {/* <select className="wide">
                        <option value={1}>Service Type</option>
                        <option value={2}>Option 1</option>
                        <option value={3}>Option 2</option>
                        <option value={4}>Option 3</option>
                      </select> */}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="single-input">
                      <textarea
                        rows={5}
                        placeholder="How can we help you?"
                        defaultValue={""}
                      />
                    </div>
                    <div className="button mt-30">
                      <button className="theme-btn3" type="submit">
                        Send{" "}
                        <span className="arrow1">
                          <i className="fa-solid fa-arrow-right" />
                        </span>
                        <span className="arrow2">
                          <i className="fa-solid fa-arrow-right" />
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="contact2-image mt-60 image-anime reveal ml-40 md:ml-0 sm:ml-0 md:mt-30 sm:mt-30">
            <img
              className="w-full"
              src="assets/img/others/contact2-image.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  {/*===== CONTACT AREA END =====*/}
  {/*===== CHOOSE AREA START =====*/}
  <div className="choose2 sp sec-bg2">
    <div className="container">
      <div className="row">
        <div className="col-lg-6">
          <div className="choose2-images mr-40 sm:mr-0 md:mr-0">
            <div className="image1 image-anime reveal">
              <img src="assets/img/others/choose2-image1.png" alt="" />
            </div>
            <div className="image2 image-anime reveal">
              <img src="assets/img/others/choose2-image2.png" alt="" />
            </div>
          </div>
        </div>
        <div className="col-lg-6 sm:mt-30 md:mt-30">
          <div className="heading2">
            <span
              className="sub-title"
              data-aos="zoom-in-left"
              data-aos-duration={900}
            >
              <img src="assets/img/icons/span3.svg" alt="" />
              WHY CHOOSE US{" "}
            </span>
            <h2 className="text-anime-style-3">Your Success, Our Priority</h2>
            <p className="mt-16" data-aos="fade-right" data-aos-duration={800}>
              Proven track record of boosting engagement and sales. Expert team
              fluent in the latest trends and technologies. Dedicated account
              managers ensuring personalized service.
            </p>
            <div className="choose2-apps">
              <div className="row">
                <div
                  className="col-lg-6"
                  data-aos="fade-up"
                  data-aos-duration={900}
                  data-aos-delay={200}
                >
                  <div className="choose2-single-apps">
                    <div className="apps-image">
                      <img src="assets/img/apps/choose-app1.png" alt="" />
                    </div>
                    <div className="apps-info">
                      <h4>12,570+</h4>
                      <p>Account Boosted</p>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-6"
                  data-aos="fade-up"
                  data-aos-duration={900}
                  data-aos-delay={300}
                >
                  <div className="choose2-single-apps">
                    <div className="apps-image">
                      <img src="assets/img/apps/choose-app2.png" alt="" />
                    </div>
                    <div className="apps-info">
                      <h4>350+</h4>
                      <p>Account Managed</p>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-6"
                  data-aos="fade-up"
                  data-aos-duration={900}
                  data-aos-delay={350}
                >
                  <div className="choose2-single-apps">
                    <div className="apps-image">
                      <img src="assets/img/apps/choose-app3.png" alt="" />
                    </div>
                    <div className="apps-info">
                      <h4>5,482+</h4>
                      <p>Account Optimized</p>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-6"
                  data-aos="fade-up"
                  data-aos-duration={900}
                  data-aos-delay={400}
                >
                  <div className="choose2-single-apps">
                    <div className="apps-image">
                      <img src="assets/img/apps/choose-app4.png" alt="" />
                    </div>
                    <div className="apps-info">
                      <h4>5,558+</h4>
                      <p>Account Grow</p>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-6"
                  data-aos="fade-up"
                  data-aos-duration={900}
                  data-aos-delay={450}
                >
                  {/* <div className="choose2-single-apps">
                    <div className="apps-image">
                      <img src="assets/img/apps/choose-app5.png" alt="" />
                    </div>
                    <div className="apps-info">
                      <h4>4,568+</h4>
                      <p>User Hired</p>
                    </div>
                  </div> */}
                </div>
                <div
                  className="col-lg-6"
                  data-aos="fade-up"
                  data-aos-duration={900}
                  data-aos-delay={500}
                >
                  {/* <div className="choose2-single-apps">
                    <div className="apps-image">
                      <img src="assets/img/apps/choose-app6.png" alt="" />
                    </div>
                    <div className="apps-info">
                      <h4>9,587+</h4>
                      <p>Account Promoted</p>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/*===== CHOOSE AREA END =====*/}
  <div className="contact-map-page">
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d196064.65881483705!2d88.93201515862421!3d24.061083775097945!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39febca82f6a21ed%3A0x4040980d7c6874f8!2sKushtia%20District!5e0!3m2!1sen!2sbd!4v1673751720794!5m2!1sen!2sbd"
      width={600}
      height={450}
      style={{ border: 0 }}
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    />
  </div>
</main>
<Footer/>
        </>
    )
}

export default Contact;